import React, { useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { ITagsCreateDto } from "../../../../types/tags.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddTagsForm: React.FC<Props> = (props) => {
  const [name, setName] = useState<string>("");
  const [note, setNote] = useState<string>("");

  const onApply = async () => {
    if (!name) {
      toast.error('Поле "Назва" обовʼязкове');
      return;
    }
    try {
      const body: ITagsCreateDto = {
        name,
        note,
      };
      const response = await authApiService.createTag(body);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Сталась помилка. Спробуйте пізніше");
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form}>
        <EditInput
          value={name}
          setValue={(value) => setName(value)}
          title="Назва"
          isRequired={true}
        ></EditInput>
        <EditInput
          value={note}
          setValue={(value) => setNote(value)}
          title="Примітка"
          isRequired={false}
          isBig={true}
        />
      </form>
      <ModalBottomButtons
        onPressBack={props.onClose}
        onPressApply={onApply}
        backTitle="Назад"
        applyTitle="Додати постачальника"
      />
    </div>
  );
};

export default AddTagsForm;
